export default __webpack_public_path__ + "static/media/logo-black.3d09c084.png";